"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class PeriodNotFoundException extends exception_1.OutOfRangeException {
    constructor(dateRange) {
        super(`No Period in range ${dateRange.from} - ${dateRange.to}`);
    }
}
exports.default = PeriodNotFoundException;
//# sourceMappingURL=PeriodNotFoundException.js.map